import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@material/material.module';
import {
  AutoCompleteComponent,
  AvatarComponent,
  BottomSheetComponent,
  ButtonComponent,
  CalendarEmptyHeaderComponent,
  CardComponent,
  CheckboxCardComponent,
  CheckboxComponent,
  ChipComponent,
  ChipTogglerComponent,
  CustomSVGIconComponent,
  ClickOutsideDirective,
  CommentComponent,
  CustomTableCellDirective,
  DateFormatPipe,
  DatepickerComponent,
  DaterangeComponent,
  DateRangePickerComponent,
  DotsComponent,
  EllipsisTooltipsDirective,
  ExpansionPanelComponent,
  ExtendableNumberPODirective,
  FullPageLoaderComponent,
  IconComponent,
  ImageComponent,
  InitCapsPipe,
  InputComponent,
  InputFieldComponent,
  InputSearchComponent,
  LabelledTableComponent,
  LabelMultiSelectComponent,
  LabelRadioComponent,
  LabelSelectComponent,
  MaxRangeCalendarDirective,
  MobileHeaderComponent,
  ModalComponent,
  ModalDrawerLayoutComponent,
  MultipleDatePickerComponent,
  MultiSelectComponent,
  NotificationComponent,
  PaginatorComponent,
  QueryValuePipe,
  RadioButtonComponent,
  ResponsiveLayoutComponent,
  SearchComponent,
  SelectableDetailCardComponent,
  SelectComponent,
  SidenavComponent,
  SlideToggleComponent,
  SpinnerComponent,
  StatusValuePipe,
  SuffixCellContentDirective,
  TableComponent,
  TextareaComponent,
  TextComponent,
  TitleCheckboxOptionsComponent,
  TitleSubtitleComponent,
  TooltipComponent,
  ValueQuantityPipe
} from '.';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}



@NgModule({
  declarations: [
    AvatarComponent,
    ButtonComponent,
    CardComponent,
    CheckboxComponent,
    CommentComponent,
    IconComponent,
    ImageComponent,
    InitCapsPipe,
    DateFormatPipe,
    InputComponent,
    ModalComponent,
    NotificationComponent,
    RadioButtonComponent,
    SelectComponent,
    SidenavComponent,
    SpinnerComponent,
    TextComponent,
    TooltipComponent,
    LabelledTableComponent,
    ChipComponent,
    TableComponent,
    TitleSubtitleComponent,
    TextareaComponent,
    SearchComponent,
    ModalDrawerLayoutComponent,
    InputFieldComponent,
    LabelRadioComponent,
    LabelSelectComponent,
    DatepickerComponent,
    TitleCheckboxOptionsComponent,
    CustomSVGIconComponent,
    AutoCompleteComponent,
    MobileHeaderComponent,
    ResponsiveLayoutComponent,
    PaginatorComponent,
    DaterangeComponent,
    ExpansionPanelComponent,
    CheckboxCardComponent,
    ChipTogglerComponent,
    InputSearchComponent,
    SelectableDetailCardComponent,
    MultiSelectComponent,
    LabelMultiSelectComponent,
    MaxRangeCalendarDirective,
    ClickOutsideDirective,
    ExtendableNumberPODirective,
    FullPageLoaderComponent,
    DateRangePickerComponent,
    BottomSheetComponent,
    DotsComponent,
    SuffixCellContentDirective,
    StatusValuePipe,
    ValueQuantityPipe,
    SlideToggleComponent,
    EllipsisTooltipsDirective,
    CustomTableCellDirective,
    MultipleDatePickerComponent,
    QueryValuePipe,
    CalendarEmptyHeaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    AutoCompleteComponent,
    AvatarComponent,
    ButtonComponent,
    CardComponent,
    CheckboxComponent,
    CommentComponent,
    CommonModule,
    ExpansionPanelComponent,
    FormsModule,
    IconComponent,
    ImageComponent,
    InitCapsPipe,
    DateFormatPipe,
    InputComponent,
    DaterangeComponent,
    ModalComponent,
    MultiSelectComponent,
    NotificationComponent,
    RadioButtonComponent,
    ReactiveFormsModule,
    SelectComponent,
    SidenavComponent,
    SpinnerComponent,
    CustomSVGIconComponent,
    TextComponent,
    TableComponent,
    ClickOutsideDirective,
    TextareaComponent,
    TooltipComponent,
    TitleCheckboxOptionsComponent,
    LabelledTableComponent,
    ChipComponent,
    ModalDrawerLayoutComponent,
    SearchComponent,
    TranslateModule,
    TitleSubtitleComponent,
    InputFieldComponent,
    LabelRadioComponent,
    LabelSelectComponent,
    DatepickerComponent,
    MobileHeaderComponent,
    ResponsiveLayoutComponent,
    PaginatorComponent,
    CheckboxCardComponent,
    ChipTogglerComponent,
    InputSearchComponent,
    SelectableDetailCardComponent,
    LabelMultiSelectComponent,
    MaxRangeCalendarDirective,
    ExtendableNumberPODirective,
    FullPageLoaderComponent,
    DateRangePickerComponent,
    BottomSheetComponent,
    DotsComponent,
    SuffixCellContentDirective,
    StatusValuePipe,
    ValueQuantityPipe,
    SlideToggleComponent,
    EllipsisTooltipsDirective,
    CustomTableCellDirective,
    MultipleDatePickerComponent,
    QueryValuePipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

})
export class EDSModule { }
